import { useEffect } from "react";

// All critical images used across the site
const PRELOAD_IMAGES = [
  "/assets/images/hero.png",
  "/assets/images/logo-banner.png",
  "/assets/images/beforeafter/deck-before.webp",
  "/assets/images/beforeafter/deck-after.webp",
  "/assets/images/beforeafter/woodrot-before.webp",
  "/assets/images/beforeafter/woodrot-after.webp",
  "/assets/images/beforeafter/exterior-before.jpeg",
  "/assets/images/beforeafter/exterior-after.png",
  "/assets/images/beforeafter/interior-before.webp",
  "/assets/images/beforeafter/interior-after.webp",
  "/assets/images/technicians/dishwasher.png",
  "/assets/images/technicians/fridge.png",
  "/assets/images/technicians/oven.png",
  "/assets/images/technicians/hoodfan.png",
  "https://images.unsplash.com/photo-1591825729269-caeb344f6df2?w=1920&q=85",
  "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=1920&q=85",
  "https://images.unsplash.com/photo-1562259949-e8e7689d7828?w=1920&q=85",
  "https://images.unsplash.com/photo-1581858726788-75bc0f6a952d?w=1920&q=85",
  "https://images.unsplash.com/photo-1581578731548-c64695cc6952?w=1920&q=85",
];

export default function ImagePreloader() {
  useEffect(() => {
    // Preload images in the background after initial render
    const timer = setTimeout(() => {
      PRELOAD_IMAGES.forEach((src) => {
        const img = new Image();
        img.src = src;
      });
    }, 1000); // Delay 1s to not compete with initial page load

    return () => clearTimeout(timer);
  }, []);

  return null;
}
